import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "../../store/store";

interface RequireAuthProps {
  children: React.ReactNode;
  allowedRoles: Array<"seller" | "buyer" | "agency" | "admin">;
}

const RequireAuth = ({ allowedRoles, children }: RequireAuthProps) => {
  const { user } = useSelector((state: RootState) => state.auth);
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user?.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

export default RequireAuth;
